export const txt2dom = (str) =>
  new DOMParser().parseFromString(str, "text/html").body.childNodes

// get rid of this
// only difference is it returns a single parent element
export const txt2dom2 = (str) =>
  new DOMParser().parseFromString(str, "text/html").body

export function sleep(time) {
  return new Promise((resolve) => setTimeout(resolve, time))
}

export function getKey(event) {
  let key = [event.keyIdentifier, event.key]
    .filter((e) => e !== undefined)
    .map((e) => e.toLowerCase())
    .pop(0)

  let name
  switch (key) {
    case "arrowup":
      name = "up"
      break
    case "arrowdown":
      name = "down"
      break
    case "arrowleft":
      name = "left"
      break
    case "arrowright":
      name = "right"
      break
    default:
      name = key
  }

  if (event.metaKey) {
    name = `meta-${name}`
    if (name === "meta-meta") {
      name = "meta"
    }
  }
  return name
}
